module.exports = __webpack_public_path__ + "static/media/Logo2025Grey.f7c3d378.svg";